import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { registerUser } from '../api/authApi';
import { AuthContext } from '../context/authContext';

const RegisterPage = () => {
  const navigator = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [username, setUsername] = useState('');
  const [message, setMessage] = useState('');
  const { setUser } = useContext(AuthContext);

  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      const data = await registerUser(username, email, password);
      localStorage.setItem('token', data.token);
      setUser({ token: data.token });
      navigator('/');
    } catch (error) {
      setMessage(error.message);
    }
  };

  return (
    <div className="tgme_page auth_page">
      <div className="tgme_page_wrap">
        <h3>Создайте свой аккаунт</h3>
        <form onSubmit={handleRegister}>
          <div>
            <label>Имя:</label>
            <input
              placeholder="Введите ваше имя"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div>
            <label>Email:</label>
            <input
              placeholder="Введите почту"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div>
            <label>Пароль:</label>
            <input
              placeholder="Введите пароль"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {message && <p>{message}</p>}
          <button type="submit">Зарегистрироваться</button>
        </form>
        <span onClick={() => navigator('/auth/login')}>
          У вас уже есть аккаунта? Войдите в свой аккаунт!
        </span>
      </div>
    </div>
  );
};

export default RegisterPage;
